import React from 'react';
import { Tools } from '../Tools';

class ProductItem extends React.Component {

    constructor(props) {
        super(props);
        this.product = this.props.data;
    }

    renderGender(features) {

        features = features.filter(feature => (feature.id_feature == 1 && feature.id_feature_value <= 4));
        
        return(
            <div className="product__gender">
                {features.map( (feature, index) => 
                    <figure className="ui-ico" key={index}>
                        <img loading="lazy" src={`${wp_core.theme_url}/assets/svg/gender/${feature.id_feature_value}.svg`} alt={feature.value} />
                    </figure>
                )}
            </div>
        );


    }

    renderPrice() {

        let product = this.product;

        if(product.reduction) {

            return (
                <React.Fragment>
                    <span className="price price--old">{Tools.formatCurrency(product.price_without_reduction, wp_core.currency)}</span>
                    <span className="price price--new">{Tools.formatCurrency(product.price, wp_core.currency)}</span>
                </React.Fragment>
            )
            
        } else {

            return (
                <span className="price price--regular">{Tools.formatCurrency(product.price, wp_core.currency)}</span>
            )

        }

    }    

	render() {

        let product = this.product;

		return (
            <li className="list__item item--product" itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">

                <meta itemProp="position" content={this.props.index} />
                <meta itemProp="image" content={product.images[0].url.large} />

                <div className="item__cover">
                    <a href={product.link}>
                        <figure className="product__image">
                            <picture>
                                <source media="(max-width: 480px)" srcSet={product.images[0].url.small} />
                                <img loading="lazy" className="image--primary" src={product.images[0].url.medium} alt={product.legend} width="720" height="720" />
                            </picture>

                            {product.images.length > 1 &&
                                <picture>
                                    <source media="(max-width: 480px)" srcSet={product.images[1].url.small} />
                                    <img loading="lazy" className="image--secondary" src={product.images[1].url.medium} alt={product.images[1].legend} width="720" height="720" />
                                </picture>                    
                            }
                        </figure>   

                        {this.renderGender(product.features)}
                               
                    </a>
                </div>

                <div className="item__meta">
                    {product.manufacturer_name &&
                        <figure className="product__manufacturer">
                            <img loading="lazy" src={product.manufacturer_image_url} alt={product.manufacturer_name} />
                        </figure>
                    }
                
                    <a href={product.link} itemProp="url">
                        <h3 className="product__name">{product.name}</h3>
                    </a>
                
                    {product.show_price > 0 &&
                        <div className="product__prices">
                            {this.renderPrice()}
                        </div>
                    } 
                </div>
            </li>
		);
	}
}

export default ProductItem;